import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';


@Component({
  selector: 'app-classification',
  templateUrl: './classification.component.html',
  styleUrls: ['./classification.component.css']
})

export class ClassificationComponent implements OnInit {
  drugForm: FormGroup;
  myControl = new FormControl('');
  drug: Drug = new Drug();
  //drugList = ['Olaparib', 'Pazopanib', 'Vemurafenib', 'Sunitinib', 'Everolimus', 'Sorafenib']
  drugList: Array<string> = [];

  filteredDrugs: Observable<string[]> = new Observable<string[]>();

  constructor(fb: FormBuilder, private http: HttpClient) {
    this.http.get('./res/drugs_with_targets.txt').subscribe((data:any) => {
      this.drugList = data;
      this.drugList.sort();
    });

    this.drugForm = fb.group({
      drugName: ['', { validators: [Validators.required] }],
    })
    // this.http.get('https://mtb.bioinf.med.uni-goettingen.de/drugon2/v1/fullDrugAnnotation/' + 'pazopanib').subscribe((json: any) => {
    //   this.drug.fill_data(json);
    //   console.log(this.drug);
    // });
  }

  ngOnInit() {
    this.filteredDrugs = this.drugForm.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value.drugName || '')),
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    let temp = this.drugList.filter(drugList => !drugList.toLowerCase().includes(','));
    temp = temp.filter(temp => !temp.toLowerCase().includes('('));
    temp = temp.filter(temp => !temp.toLowerCase().includes('-'));
    return temp.filter(temp => temp.toLowerCase().startsWith(filterValue)).slice(0, 25);
  }

  getDrugInfo() {
    //console.log(this.drugForm.value.drugName);
    console.log(this.drugForm.value.drugName);
    this.drug = new Drug();
    //this.http.get('https://mtb.bioinf.med.uni-goettingen.de/drugon2/v1/fullDrugAnnotation/' + this.drugForm.value.drugName.toLowerCase()).subscribe((json: any) => {
    if (this.drugForm.value.drugName != null){
      this.http.get('https://mtb.bioinf.med.uni-goettingen.de/drugon2/v1/fullDrugAnnotation/' + this.drugForm.value.drugName.toLowerCase()).subscribe((json: any) => {
        this.drug.fill_data(json);
        //console.log(this.drug);
        this.drugForm.reset();
      });
    }
    else {
      console.log("No drug selected");
    }
  }
}

class Drug {
  name: string = "";
  class: string = "";
  identifiers: [] = [];
  synonyms: [] = [];
  targets: { 'pharmacological': string, 'non_pharmacological': string } = { 'pharmacological': "", 'non_pharmacological': "" };
  sources: { 'atc': string, 'mesh': string, 'clue_io': string, 'kegg_class': string, 'kegg_group': string } = { 'atc': "", 'mesh': "", 'clue_io': "", 'kegg_class': "", 'kegg_group': "" };

  fill_data(json: any) {
    console.log(json[0]['data']);
    if (json[0]['data'] != null) {
      this.name = json[0]['header']['qid'];
      this.class = json[0]['data']['drug_class'];
      this.identifiers = json[0]['data']['identifiers'];
      this.sources = json[0]['data']['sources'];
      this.synonyms = json[0]['data']['synonyms'];
      this.targets = json[0]['data']['targets'];
    }
    else{
      this.name = json[0]['header']['qid'];
    }
  }
}
